import React from 'react';
import './openEnded.sass';
// import PropTypes from 'prop-types';

/* Component for open-ended question types.
Takes in a question and displays a year dropdown for input
*/

const YearQuestion = ({ value, onChange, question, user }) => {
  question.questionText = question.questionText.replace(/\{user\}/gi, user);
  const currentYear = new Date().getFullYear();
  const latestAllowedYear = currentYear - 18;

  return (
    <div className="open-ended-container">
      <h4 className="range-score-question">
        <p className="question-text" dangerouslySetInnerHTML={{ __html: question.questionText }} />
      </h4>

      {question.questionText !== 'You have already completed this survey.' && (
        <select
          className="simple-dropdown"
          style={{ width: '100%', height: '38px', fontSize: '14px' }}
          onChange={(e) => {
            const index = e.target.value;
            const text = index;

            onChange({ value: index, text }, question.questionID, question.questionLevel);
          }}
          value={value || ''}
        >
          <option value="">Select an option</option>

          {Array.from({ length: 100 }, (_, i) => {
            const year = latestAllowedYear - i;
            return (
              <option key={year} value={year}>
                {year}
              </option>
            );
          })}
        </select>
      )}
    </div>
  );
};

export default YearQuestion;
